import { Flex } from "antd";
import type { FC } from "react";
import { countText } from "tm-shared/utils";

import BaseButton from "@/components/BaseButton";
import { BaseModal } from "@/components/BaseModal";
import { MarketCardBase } from "@/components/MarketCardBase";
import { PrimaryText } from "@/components/Typography/Styled";
import { MarketCreateModal, MarketCreateModalPayloads } from "@/types/modals";

interface DuplicateByIdModalProps {
    onClose: () => void;
    payload: MarketCreateModalPayloads[MarketCreateModal.DuplicateById];
}

export const DuplicateByIdModal: FC<DuplicateByIdModalProps> = ({
    onClose,
    payload,
}) => {
    const { market, routeCount } = payload;

    const hasRoutes = routeCount > 0;

    const marketStatus = hasRoutes
        ? "hasRoutes"
        : market.isArchived
          ? "archived"
          : null;

    return (
        <BaseModal
            open
            onClose={onClose}
            maskClosable={false}
            title={"Увага"}
            closable={false}
            actions={null}
        >
            <Flex vertical gap={24} style={{ minHeight: 0 }}>
                <PrimaryText fontSize={16}>
                    Торгова точка з ID {market.externalMarketId} вже існує
                </PrimaryText>

                <MarketCardBase
                    market={market}
                    isChild={false}
                    status={marketStatus}
                    bottomSlot={
                        hasRoutes && (
                            <PrimaryText $textColor="error">
                                Ця ТТ знаходиться у{" "}
                                {countText.route(routeCount)}
                            </PrimaryText>
                        )
                    }
                />

                <BaseButton type="default" size="large" onClick={onClose}>
                    Ok
                </BaseButton>
            </Flex>
        </BaseModal>
    );
};
